import { LifestyleRulesPageTemplate } from "./template";
import { useLifestyleRulesPage } from "./logic";

export const LifestyleRulesPage = () : JSX.Element => {
    const props = useLifestyleRulesPage();

    return (
        <LifestyleRulesPageTemplate {...props}/>
    )
} 